import END_POINTS from './EndPoints';
import Actions from "../action";
import { doGet } from '../../service/index';
import { put, takeLatest } from 'redux-saga/effects';

import {
  GET_HEALTH_CHECK_DATA,
  GET_DOWNTIME_REPORT,
} from '../action/HealthCheckAction';

function* getHealthCheckDataSaga({ params, callback }) {
  try {
    const response = yield doGet(END_POINTS.HEALTH_CHECK_LIST, params);
    yield put(Actions.getHealthCheckDataSuccess(response || {}));
    if (callback) callback(response);
  } catch (error) {
    yield put(Actions.getHealthCheckDataFailure({ error }));
    if (callback) callback(error);
  }
}

function* getDowntimeReportSaga({ params, callback }) {
  try {
    const response = yield doGet(END_POINTS.DOWNTIME_REPORT, params);
    yield put(Actions.getDowntimeReportSuccess(response?.response));
    if (callback) callback(response);
  } catch (error) {
    yield put(Actions.getDowntimeReportFailure({ error }));
    if (callback) callback(error);
  }
}

export default function* rootSaga() {
  yield takeLatest(GET_HEALTH_CHECK_DATA, getHealthCheckDataSaga);
  yield takeLatest(GET_DOWNTIME_REPORT, getDowntimeReportSaga);
}
